// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  productId: 'e71fc875f5f644b79a7660d3cbaf3c04',
  applyRedirect: 'https://apply.zeropay.co.za',
  portalRedirect: 'https://app.zeropay.co.za/#/',
  adminUrl: 'https://localhost:5001',
  api: {
    pub: {
      host: 'https://pub.fevertreefinance.co.za',
    },
    marketing: {
      host: 'https://admin.ft-svc-01.co.za/api-marketing',
      accessKey: 'ft_10c96a9a8b4b48048bb1d1efc1bb5f93',
    },
  },
  products: {
    host: 'https://dev.ft-svc-02.co.za/products-v2',
    accessKey: 'ft_babf5d5f6fdd41bda405cdd94da7aca2',
  },
  zeropay: {
    host: 'https://zeropay-portal.ft-svc-00.co.za',
    accessKey:
      'FT_0D2C340A47BC45D0BBCB783FB2AFA474DCC69C13DF6B4D5DBC3B83987AF08494',
    sourceId: 'f952139e275143b78580254fa5868d54',
  },
  partnerSignUp: {
    appKey: 'ZGVjZjJmMDMtZDYzNS00OWFiLWJmZWEtYTM1MzU2YzJlNjc1',
    driveAppKey: 'ZDBmYTIyZWMtMGRjZi00NWY3LTlmODktYzEwZmFlOWQxNzVi',
    appURL: 'https://applications.fevertreefinance.co.za',
    driveURL: 'https://drive.fevertreefinance.co.za',
    partnerURL: 'https://localhost:5001',
    partnerKey: 'MWIyZjI4ZWQtZjVhNy00NWY0LTgwZjItYTgzMzdkMTg1ZWYz',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
